document.addEventListener("DOMContentLoaded", () => {
  new Swiper(".product-media-swiper", {
    loop: true, 
    slidesPerView: 1,
    spaceBetween: 10,
    
    watchOverflow: true, 

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  Fancybox.bind('[data-fancybox="product-gallery"]', {
    Thumbs: false,
    Toolbar: {
      display: ["close"],
    },
  });
});